module.exports = __webpack_public_path__ + "static/ML_SmartPci@2x-40c8b7009d8aea91e1bfb41cf9ab2ed5.png";